import React from 'react'
import PropTypes from 'prop-types'
import { DimmableBox } from '../DimmableBox'
import { useIsItemAttributionScoped } from './hooks'
import { useAttributionScope } from '../../../hooks'

export function AttributionScopedItem({ children, style, itemScope, ...rest }) {
  const [scope] = useAttributionScope()
  const itemScoped = useIsItemAttributionScoped(itemScope, scope)
  return (
    <DimmableBox dimmed={!itemScoped} style={style} {...rest}>
      {children}
    </DimmableBox>
  )
}

AttributionScopedItem.propTypes = {
  children: PropTypes.node,
  itemScope: PropTypes.string,
  style: PropTypes.object,
}

export default AttributionScopedItem
